<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms" [formGroup]="editworkform">
  <div class="accordion-class">
    <h5>Add / Edit Trip to Work Order</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row mtb mt-3 trucksselect">
        <div class="col-sm-3 class-name">
          <mat-label>Work Order No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="work_order"
              placeholder="Work Order No"
              readonly
            />
          </mat-form-field>
        </div>
        <div class="col-sm-3 class-name">
          <mat-label>Actual Price Per Ton</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="act_ton"
              placeholder="Price Per Ton"
              readonly
            />
            <mat-error>Please Enter Actual Price</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label>Work Order Date</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="work_date"
              placeholder="DD-MM-YYYY"
              readonly
              required
            />
            <mat-error>Please Enter Work Order Date</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3 class-name">
          <mat-label>Work Order Qty</mat-label>
        </div>
        <div class="col-sm-2">
          <mat-form-field>
            <input
              matInput
              appThreeDigitDecimalNumber
              formControlName="workorder_qty"
              placeholder="Enter WO Qty"
              required
              (focusout)="remainingQnty($event)"
            />
            <mat-error>Please Enter Work Order Qty</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-1">
          <p class="tons">Tons</p>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label class="remaining">Remaining Qty</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input matInput formControlName="remaining_tons" readonly />
          </mat-form-field>
        </div>
        <div class="col-sm-3 class-name">
          <mat-label class="remaining">Total Qty</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input matInput formControlName="total_tons" readonly />
          </mat-form-field>
        </div>
      </div>
      <mat-divider class="divider_mat"></mat-divider>
      <div class="row mtb">
        <div class="col-sm-12">
          <h6>Trip Details</h6>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label>Trip Booking Date</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <mat-datepicker #picker></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="DD-MM-YYYY"
              [min]="minDate"
              formControlName="tripbooking_date"
              (click)="picker.open()"
              required
            />
            <mat-error>Please Enter Trip Booking Date </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3 class-name">
          <mat-label>Vehicle No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field class="flex-gt-sm truck-type-input">
            <mat-select
              dropLocationSearchField
              formControlName="truck_id"
              placeholder="Select vehicle No"
              (selectionChange)="getVehiclesList($event)"
              required
            >
              <mat-option
                *ngFor="let item of truckArray"
                value="{{ item._id }}"
              >
                {{ item.truck_number }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label>Driver Name</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="driver_id"
              placeholder="Enter Driver Name"
              readonly
            />
            <mat-error>Please Enter Driver Name</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3 class-name">
          <mat-label>Driver No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="driver_no"
              placeholder="Enter Driver No"
              maxlength="10"
              minlength="10"
              readonly
            />
            <mat-error>Please Enter Driver No</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label>Truck Owner Name</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              type="text"
              matInput
              formControlName="truck_name"
              placeholder="Truck Owner Name"
              readonly
            />
            <mat-error>Please Enter Truck Owner Name </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3 class-name">
          <mat-label>Truck Owner No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="truck_no"
              placeholder="Truck Owner No"
              maxlength="10"
              minlength="10"
              readonly
            />
            <mat-error>Please Enter Truck Owner No</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label>Net Quantity <br />(Loading Point)</mat-label>
        </div>

        <div class="col-sm-3">
          <mat-form-field>
            <input
              appTwoDigitDecimaNumber
              type="number"
              matInput
              formControlName="loading_point"
              placeholder="Loading Point QTY"
              pattern="^\d+(\.\d{1,3})?$"
              (input)="validateDecimal($event, 'loading_point')"
              (wheel)="disableScroll($event)"
            />
            <!-- <mat-error
              *ngIf="editworkform.controls['loading_point'].hasError('pattern')"
            >
              Please enter a valid number with up to 3 decimals
            </mat-error> -->
          </mat-form-field>
        </div>

        <div class="col-sm-3 class-name">
          <mat-label>Net Quantity <br />(UnLoading Point)</mat-label>
        </div>

        <div class="col-sm-3">
          <mat-form-field>
            <input
              type="number"
              matInput
              appTwoDigitDecimaNumber
              formControlName="unloading_point"
              placeholder="UnLoading Point QTY"
              (input)="validateDecimal($event, 'unloading_point')"
              (wheel)="disableScroll($event)"
            />
            <!-- <mat-error
              *ngIf="
                editworkform.controls['unloading_point'].hasError('pattern')
              "
            >
              Please enter a valid number with up to 3 decimals
            </mat-error> -->
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label>Price Per Ton</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="price_per_ton"
              placeholder="Price Per Ton"
              required
            />
            <mat-error>Please Enter Price Per Ton</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3 class-name">
          <mat-label>Sales Order No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="sales_order_number"
              placeholder="Sales Order No"
              required
              appAlphanumericOnly
              toUppercase
              maxlength="16"
            />
            <mat-error>Please Enter Sales Order No </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label>LR No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="lr_number"
              placeholder="Enter LR No"
              required
              appAlphanumericOnly
              toUppercase
              maxlength="16"
            />
            <mat-error>Please Enter LR No</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3 class-name">
          <mat-label>LR Date</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <mat-datepicker #picker1></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker1"
              placeholder="DD-MM-YYYY"
              [max]="maxDate"
              formControlName="lr_date"
              (click)="picker1.open()"
              appCustomDateFormat
              required
            />
            <mat-error>Please Enter LR Date </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label>Tax Invoice No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="tax_invoice_no"
              placeholder="Enter Tax Invoice No"
              required
              toUppercase
              maxlength="16"
              (keypress)="validateTaxInvoiceInput($event)"
            />
            <mat-error>Please Enter Tax Invoice No</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3 class-name">
          <mat-label>DDC No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="ddc_no"
              placeholder="Enter DDC No"
              required
              appAlphanumericOnly
              toUppercase
              maxlength="16"
            />
            <mat-error>Please Enter DDC No</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3 class-name">
          <mat-label>Truck ETA</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <mat-datepicker #picker2></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker2"
              placeholder="DD-MM-YYYY"
              [min]="minTruckEta"
              formControlName="truck_eta"
              (click)="picker2.open()"
            />
            <!-- <mat-error>Please Enter Truck ETA </mat-error> -->
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-7">
      <!-- <button
        type="submit"
        [class.spinner]="loading"
        class="button buttonBlue"
        (click)="addWorkOrderTrips($event)"
        style="margin-bottom: 10px"
      >
        Submit
      </button> -->
      <button
        type="submit"
        [class.spinner]="loading"
        class="button buttonBlue"
        (click)="handleWorkOrderSubmission($event)"
        style="margin-bottom: 10px"
      >
        Submit
      </button>
    </div>
  </div>
</form>
